exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-button[data-v-e2926dca] {\n  min-width: 140px;\n}\n", ""]);

// exports
